import React from "react";
import { Sizes } from "src/@types/sizes";
import logo from "src/assets/images/logo-colored.png";
import { Loader } from ".";

export const ScreenLoader = () => (
  <div className="absolute top-0 left-0 flex flex-col justify-center items-center gap-5 w-full h-full bg-white-base">
    <img src={logo} alt="business clone" />
    <Loader size={Sizes.M} />
  </div>
);
